<div *ngIf="artist">
  <app-card [type]="2" [imgSrc]="artist.avatarUrl | mediaUrl" [title]="'feature.artist.artist_info' | translate" [showEditButton]="false">
    <div cardText2>
      <h6 class="d-inline">{{ 'feature.artist.artist_name' | translate }}:&nbsp;</h6>
      <span>{{artist.name}}</span><br />
      <h6 class="d-inline">{{ 'common.label.birthDate' | translate }}:&nbsp;</h6>
      <span>{{artist.birthDate | date: 'dd/MM/yyyy'}}</span><br />
      <h6 class="d-inline">{{ 'feature.artist.biography' | translate }}:&nbsp;</h6>
      <p style="overflow-wrap: break-word">{{artist.biography}}</p>
    </div>
  </app-card>
</div>
<h3 class="text-center">{{ 'feature.song.song_list' | translate }}</h3>
<div
  class="songList py-2"
  infiniteScroll
  [scrollWindow]="false"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="50"
  (scrolled)="onScroll()"
>
  <table class="table table-striped py-2">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">{{ 'common.label.title' | translate }}</th>
        <th scope="col">{{ 'feature.song.release_date' | translate }}</th>
        <th scope="col"></th>
        <th scope="col"></th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr [routerLink]="['/song/detail']" [queryParams]="{id: song.id}" *ngFor="let song of songPage.content; index as i">
        <th scope="row">{{ i + 1 }}</th>
        <td>
          <a [routerLink]="['/song','detail']" [queryParams]="{id: song.id}"><h5>{{song.title}}</h5></a>
          <a *ngFor="let artist of song.artists; index as j"
            ><small>{{ artist.name }}{{ j === song.artists.length - 1 ? '' : ', '}}</small></a
          >
        </td>
        <td>
          <small>{{ song.duration | duration }}</small>
        </td>
        <td>
          <span class="float-right">
            <small><i class="bi bi-headphones"></i> {{song.listeningFrequency}}</small></span
          >
        </td>
      </tr>
    </tbody>
  </table>
</div>
